import ArticleMetaData from './ArticleMetaData';

export default ArticleMetaData;
